import React from "react";
import { teamColor, teamLogo } from "@/lib/teams";

const SIZES = { sm: "w-7 h-7", md: "w-9 h-9", lg: "w-16 h-16" };
const TEXT = { sm: "text-[10px]", md: "text-xs", lg: "text-lg" };

export default function Avatar({ team, username, size = "md" }) {
  const box = SIZES[size] || SIZES.md;
  const txt = TEXT[size] || TEXT.md;
  const [err, setErr] = React.useState(false);

  if (team && !err) {
    return (
      <span className={`${box} inline-flex items-center justify-center shrink-0`} title={team} data-testid={`avatar-logo-${team}`}>
        <img src={teamLogo(team)} alt={team} onError={() => setErr(true)} className="w-full h-full object-contain" />
      </span>
    );
  }
  if (team) {
    return (
      <span
        className={`${box} ${txt} inline-flex items-center justify-center font-['Bebas_Neue'] tracking-wide text-white shrink-0 border border-white/20`}
        style={{ backgroundColor: teamColor(team) }}
        title={team}
      >
        {team}
      </span>
    );
  }
  const initial = (username || "?").charAt(0).toUpperCase();
  return (
    <span className={`${box} ${txt} inline-flex items-center justify-center font-['Bebas_Neue'] bg-white/10 text-white/60 shrink-0 border border-white/10`}>
      {initial}
    </span>
  );
}
